jQuery(document).ready(function($) {

  let isReviewsPg = $('body#reviews').length;
  
  if ( $('body').hasClass('template-index') || $('body').hasClass('template-product') || isReviewsPg ) {
    let runCount = 0;
    const maxRuns = 10;
  
    const intervalId = setInterval(function () {
      runCount++;
  
      const $fwEmbed = $('fw-embed-feed')[0];
      if ($fwEmbed && $fwEmbed.shadowRoot) {
        const branding = $fwEmbed.shadowRoot.querySelector('a[aria-label*="Powered by Firework"]');
        if (branding) {
          branding.style.display = 'none';
        }
      }
  
      if (runCount >= maxRuns) {
        clearInterval(intervalId);
      }
    }, 1000);
  }

  let setVariantImageBackground = () => {
    let isETT = $('body').hasClass('product-id-9708866470209');
    const urlParams = new URLSearchParams(window.location.search);
    const initialVariantID = urlParams.get("variant");
  
    let bgColor;
  
    if(initialVariantID == "49799448166721") {
      bgColor = "#A4B0C3";
    } else if(initialVariantID == "49799448199489") {
      bgColor = "#94A48C";
    }

    if(!isETT) {
      return;
    }
    
    if (!initialVariantID) { 
       $('.product__slide.media--active .image-wrapper').attr('style',`background:#A4B0C3`);
    } else {
      $('.product__slide.media--active .image-wrapper').attr('style',`background:${bgColor}`);
    }
  
    

    $('input[name="options[Color]-template--24274847301953__mainproduct-9708866470209-"]').change(function() {
      let value = $(this).val();
      if(value == "Emerald Green Jar") {
        $('.product__slide.media--active .image-wrapper').attr('style',`background:#94A48C`);
      } else if(value == "Steel Blue Jar") {
        $('.product__slide.media--active .image-wrapper').attr('style',`background:#A4B0C3`);
      }
    })
  }

  setVariantImageBackground();

  // Product Pg Reviews Restructure
  function restructureJudgeMeReviewBlocks() {
    $('.jdgm-rev').each(function () {
      var $review = $(this);
      var $pics = $review.find('.jdgm-rev__pics');
      var $rating = $review.find('.jdgm-row-rating');
      var $author = $review.find('.jdgm-rev__author');
      var $content = $review.find('.jdgm-rev__content');
      var $body = $review.find('.jdgm-rev__body');
      var $title = $review.find('.jdgm-rev__title');
  
      // Move rating above title (for all)
      if ($rating.length && $title.length) {
        $title.before($rating);
      }
  
      // Append author at the end of the review text (for all)
      if ($author.length && $body.length && $body.find('.jdgm-rev__author-inline').length === 0) {
        var authorName = $.trim($author.text());
        if (authorName) {
          var $name = $('<div class="jdgm-rev__author-inline">').text('– ' + authorName);
          $body.append($name);
        }
      }

      var currentTop = parseFloat($review.css('top'));

      if (!isNaN(currentTop) && currentTop !== 0) {
        $review.css('top', (currentTop + 40) + 'px');
      }
    });
  }
  
  let restructureProductReviews = () => {
    let isProductPg = $('body').hasClass('template-product');
  
    if (isProductPg) {
      console.log("HELLO!");
  
      // Initial load
      setTimeout(() => {
        restructureJudgeMeReviewBlocks();
      }, 1500);
  
      // On pagination click
      $(document).on('click', '.jdgm-paginate__page', function () {
        setTimeout(function () {
          restructureJudgeMeReviewBlocks();
        }, 800);
      });
    }
  };
  
  restructureProductReviews();

  let isCollectionPg = $('body').hasClass('template-collection');
  $('.custom-atc-trigger').on('click', function () {
    var $productItem = $(this).closest('.product-item');
    var $realButton = $productItem.find('.quick-add__button');

    if ($realButton.length) {
      $realButton.trigger('click');
    }
  });

});


if (window.innerWidth < 769) {
  new Swiper('#jci-mobile-slider', {
    slidesPerView: 1,
    spaceBetween: 24,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });

  $('.template-product #cart-bar').addClass("is-visible");
}


const upsellCarousel = document.querySelector('.upsell-carousel.swiper-container');
if (upsellCarousel) {
  new Swiper(upsellCarousel, {
    slidesPerView: 1.1,
    spaceBetween: 16,
    grabCursor: true,
    loop: false,
    freeMode: false,
    pagination: false,
    navigation: false,
  });
}

let jciBadges = $('.jdgm-verified-badge');
jciBadges.appendTo('.footer__block--newsletter');


/* ============================================================================
   ENML fix: force cart quantity to match the selected ReCharge subscription
   plan's "Product Quantity" (3 / 6 / etc.) at add-to-cart time.

   Why: ReCharge's quantity-upsell widget writes the quantity into the product
   form's hidden `quantity` field asynchronously. If Add to Cart fires before
   that write lands, the form posts quantity=1 with the selling_plan, so the
   order ships 1 unit but keeps the subscription discount (e.g. order #8547).
   This guard reads the authoritative "Product Quantity" option from the
   product .js endpoint and re-asserts the quantity the instant the form is
   submitted, closing the race. One-time purchases are left untouched.
   ============================================================================ */
(function () {
  var QTY = {}; // { sellingPlanId : requiredQty }

  // Source of truth: each plan's "Product Quantity" option, from /products/{handle}.js
  (function loadAuthoritative() {
    try {
      fetch(location.pathname.split('?')[0] + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          (p && p.selling_plan_groups || []).forEach(function (g) {
            (g.selling_plans || []).forEach(function (pl) {
              var o = (pl.options || []).filter(function (x) { return x.name === 'Product Quantity'; })[0];
              if (o && o.value) QTY[String(pl.id)] = parseInt(o.value, 10);
            });
          });
        });
    } catch (e) {}
  })();

  // Fallback: parse the leading number from the plan name, only used until the
  // authoritative map above resolves (covers the first ~50ms after load).
  function nameFallback(planId) {
    var plans = (window.SubscriptionWidgetConfig || {}).shopifyPlans || [];
    for (var i = 0; i < plans.length; i++) {
      if (String(plans[i].id) === String(planId)) {
        var m = String(plans[i].name || '').match(/^\s*(\d+)\s+Product/i);
        return m ? parseInt(m[1], 10) : null;
      }
    }
    return null;
  }

  function enforce(form) {
    if (!form) return;
    var sp = form.querySelector('[name="selling_plan"]');
    var qty = form.querySelector('[name="quantity"]');
    if (!sp || !qty || !sp.value) return; // one-time / no plan selected -> leave as-is
    var required = QTY[String(sp.value)] || nameFallback(sp.value);
    if (required && parseInt(qty.value, 10) !== required) {
      qty.value = required;
      qty.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // Capture phase => runs BEFORE the theme/ReCharge add-to-cart handler reads the form.
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form.product-form, form[action*="/cart/add"]');
    enforce(form);
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('button[name="add"], [data-add-to-cart]');
    if (btn) enforce(btn.closest('form.product-form, form[action*="/cart/add"]'));
  }, true);
})();